import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "35ad53d5-5a8b-4182-bf8b-1374cacd5381"
// title: "Local Partnership"
// type: :html
// key: "local-partnership-page"
// parent_id: nil
export function LocalPartnershipPage35ad53d55a8b4182Bf8b1374cacd5381(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} LocalPartnershipPage35ad53d55a8b4182Bf8b1374cacd5381 gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderB802c87eF18343b0Af2943498ebbf938" parentTag={buildClassName("HeaderB802c87eF18343b0Af2943498ebbf938", parentTag)} contentSlug="local-partnership-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      <main>
        {props["page-content"] || <PageContentSimplified className="PageContent8c67e6f3Aded4fcfB9d9900c2f05701a" parentTag={buildClassName("PageContent8c67e6f3Aded4fcfB9d9900c2f05701a", parentTag)} className="main-inner" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="Footer177f0cf884724c6dAab0Bf594aacc9b4" {...props} />}
    </div>
  );
}

// id: "d9460608-ca70-4bef-b49b-a9798248b17a"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d3c1810e-b29e-4e97-bbb1-ebf98210ab3a"
export function FooterD9460608Ca704befB49bA9798248b17a(props: any) {
  return (
    <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterD9460608Ca704befB49bA9798248b17a" {...props} />
  );
}

// id: "eae672f0-c654-4db8-b6be-7f4af16704ef"
// title: ""
// type: :html
// key: "main"
// parent_id: "dde291d5-7380-429d-92b3-b71ca3a77964"
export function MainEae672f0C6544db8B6be7f4af16704ef(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainEae672f0C6544db8B6be7f4af16704ef`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="CardsA9782f8a57c841858d88E0ac8ee0147e" parentTag={buildClassName("CardsA9782f8a57c841858d88E0ac8ee0147e", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "5d112313-2001-4fb8-89f1-2fe863798112"
// title: ""
// type: :text
// key: "subType"
// parent_id: "e7e7dc0e-8d0b-4785-ada6-8c409b5a2481"
export const SubType5d11231320014fb889f12fe863798112 = "post";

// id: "b105e87e-50a0-4781-8997-dd78af443170"
// title: ""
// type: :text
// key: "class"
// parent_id: "8c67e6f3-aded-4fcf-b9d9-900c2f05701a"
export const ClassB105e87e50a047818997Dd78af443170 = "main-inner";

// id: "d5061c26-b88f-446e-885d-07fd2e3b0654"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "273edafc-dd1d-4e4d-bbb0-11d468311858"
export function QuoteD5061c26B88f446e885d07fd2e3b0654(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteD5061c26B88f446e885d07fd2e3b0654" parentTag={buildClassName("QuoteD5061c26B88f446e885d07fd2e3b0654", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "1ce00e2e-46bf-4344-bff5-c5eb99362d6a"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a footer`}>
      {props["links"] || <Navigation className="LinksFe710b4c04e34c0e940fF1d9d0d4b0b8" parentTag={buildClassName("LinksFe710b4c04e34c0e940fF1d9d0d4b0b8", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo96d3289337054b90A0e8Ef6f3b8e05cd" parentTag={buildClassName("Logo96d3289337054b90A0e8Ef6f3b8e05cd", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightB413d9a3336148f79410E528cd3edc98" parentTag={buildClassName("CopyrightB413d9a3336148f79410E528cd3edc98", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow8282c2317d784707B7bc6f6356b1c322" parentTag={buildClassName("Groupflow8282c2317d784707B7bc6f6356b1c322", parentTag)} {...props} />}
    </footer>
  );
}

// id: "fe710b4c-04e3-4c0e-940f-f1d9d0d4b0b8"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "1ce00e2e-46bf-4344-bff5-c5eb99362d6a"
export function LinksFe710b4c04e34c0e940fF1d9d0d4b0b8(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksFe710b4c04e34c0e940fF1d9d0d4b0b8" parentTag={buildClassName("LinksFe710b4c04e34c0e940fF1d9d0d4b0b8", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "b413d9a3-3361-48f7-9410-e528cd3edc98"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "1ce00e2e-46bf-4344-bff5-c5eb99362d6a"
export function CopyrightB413d9a3336148f79410E528cd3edc98(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightB413d9a3336148f79410E528cd3edc98" parentTag={buildClassName("CopyrightB413d9a3336148f79410E528cd3edc98", parentTag)} {...props} />
  );
}

// id: "3b28500a-bbde-4fa6-ab58-fbf284591d0e"
// title: ""
// type: :text
// key: "as"
// parent_id: "b51ba26e-5e77-4982-a6ee-333313ff35e4"
export const As3b28500aBbde4fa6Ab58Fbf284591d0e = "header";

// id: "82d0eb90-ce4e-4f0b-9a69-cf3dafca1b64"
// title: ""
// type: :text
// key: "title"
// parent_id: "a81d53e1-f2da-491a-a613-607853386f69"
export const Title82d0eb90Ce4e4f0b9a69Cf3dafca1b64 = "Secondary Page";

// id: "3ba28bc9-1279-46b5-9675-4e145c67530d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1f6f1921-d62f-4104-adcd-468ddf692f7d"
export const ContentSlug3ba28bc9127946b596754e145c67530d = "about-us-header-with-hero";

// id: "fd4a8154-9c63-4ca4-9839-ee69c8e0f9a4"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopFd4a81549c634ca49839Ee69c8e0f9a4(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopFd4a81549c634ca49839Ee69c8e0f9a4 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo0bc4e6196eec4350B545F9fb85b51e10" parentTag={buildClassName("LinkedLogo0bc4e6196eec4350B545F9fb85b51e10", parentTag)} label={<Logo className="Label6a8b3dc27c134697BeeaC47c49d1b610" parentTag={buildClassName("Label6a8b3dc27c134697BeeaC47c49d1b610", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} url="/" className="linked-logo" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation7994955bD8234e4c9f1e9e511370e279" parentTag={buildClassName("Navigation7994955bD8234e4c9f1e9e511370e279", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "3116ec8b-a6cd-487b-bfd6-cfbffe29d49e"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "437b53df-9db0-4fed-9ae6-8caf2083dfb9"
export function Header3116ec8bA6cd487bBfd6Cfbffe29d49e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header3116ec8bA6cd487bBfd6Cfbffe29d49e" parentTag={buildClassName("Header3116ec8bA6cd487bBfd6Cfbffe29d49e", parentTag)} className="public-header-with-hero home-page" subType="header_with_hero" contentSlug="home-header-with-hero" as="header" {...props} />
  );
}

// id: "3713f0b0-d466-4bc5-846b-094f0f2f0753"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "b802c87e-f183-43b0-af29-43498ebbf938"
export const ContentSlug3713f0b0D4664bc5846b094f0f2f0753 = "local-partnership-header-with-hero";

// id: "e5343bc0-93ab-4c04-9c7a-cb45aebea60e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "a81d53e1-f2da-491a-a613-607853386f69"
export const ContentSlugE5343bc093ab4c049c7aCb45aebea60e = "join-us-header-with-hero";

// id: "ecdd1078-3c98-4119-a8e2-7c657e601d53"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "d2611df5-0510-43b1-838f-758fd1ed89ef"
export const ContentSlugEcdd10783c984119A8e27c657e601d53 = "public-events-header-with-hero";

// id: "ed0dd5e8-7caa-4cc8-9d73-985790e7b15d"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPageEd0dd5e87caa4cc89d73985790e7b15d(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPageEd0dd5e87caa4cc89d73985790e7b15d`} classname="gf-page-layout">
      {props["header"] || <ContentItem className="HeaderA81d53e1F2da491aA613607853386f69" parentTag={buildClassName("HeaderA81d53e1F2da491aA613607853386f69", parentTag)} title="Secondary Page" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="Footer1b6fd4fc421847279cf474e718d990b9" {...props} />}
    </div>
  );
}

// id: "177f0cf8-8472-4c6d-aab0-bf594aacc9b4"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "35ad53d5-5a8b-4182-bf8b-1374cacd5381"
export function Footer177f0cf884724c6dAab0Bf594aacc9b4(props: any) {
  return (
    <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="Footer177f0cf884724c6dAab0Bf594aacc9b4" {...props} />
  );
}

// id: "af4db5ce-5060-42a5-8b0a-e380c8f6f3c4"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "277710fe-daf1-4b0e-aff6-c00eb69ec087"
export function HeaderTopAf4db5ce506042a58b0aE380c8f6f3c4(props: any) {
  return (
    <DefaultHeaderTopFd4a81549c634ca49839Ee69c8e0f9a4 parentTag="HeaderTopAf4db5ce506042a58b0aE380c8f6f3c4" {...props} />
  );
}

// id: "20eacd5a-7b02-40bb-a325-fc5099587928"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "bd6cdc05-3328-4ee9-ba92-cf12f73805b4"
export function HeaderTop20eacd5a7b0240bbA325Fc5099587928(props: any) {
  return (
    <DefaultHeaderTopFd4a81549c634ca49839Ee69c8e0f9a4 parentTag="HeaderTop20eacd5a7b0240bbA325Fc5099587928" {...props} />
  );
}

// id: "2fdf47e0-bb07-447a-b444-244d4d53b708"
// title: ""
// type: :text
// key: "as"
// parent_id: "354fb5aa-64b1-47cd-9edf-bc8501bbfe11"
export const As2fdf47e0Bb07447aB444244d4d53b708 = "header";

// id: "277710fe-daf1-4b0e-aff6-c00eb69ec087"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader277710feDaf14b0eAff6C00eb69ec087(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader277710feDaf14b0eAff6C00eb69ec087 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopFd4a81549c634ca49839Ee69c8e0f9a4 parentTag="HeaderTopAf4db5ce506042a58b0aE380c8f6f3c4" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero12dadd0b5f3b4e7eBa55C97a575513b1 parentTag="Hero6dc471dfAdf742b9A573757df71b0cea" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "0bc4e619-6eec-4350-b545-f9fb85b51e10"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "fd4a8154-9c63-4ca4-9839-ee69c8e0f9a4"
export function LinkedLogo0bc4e6196eec4350B545F9fb85b51e10(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo0bc4e6196eec4350B545F9fb85b51e10" parentTag={buildClassName("LinkedLogo0bc4e6196eec4350B545F9fb85b51e10", parentTag)} label={<Logo className="Label6a8b3dc27c134697BeeaC47c49d1b610" parentTag={buildClassName("Label6a8b3dc27c134697BeeaC47c49d1b610", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} url="/" className="linked-logo" {...props} />
  );
}

// id: "a0883012-e397-431d-9369-36b36a04881c"
// title: ""
// type: :reference
// key: "header"
// parent_id: "1b7e4624-5cf8-4c7c-b1ab-2ad4d5cdd502"
export function HeaderA0883012E397431d936936b36a04881c(props: any) {
  return (
    <SecondaryMarketingHeader277710feDaf14b0eAff6C00eb69ec087 parentTag="HeaderA0883012E397431d936936b36a04881c" title="Join Us" {...props} />
  );
}

// id: "aa11e73e-60a3-400a-b40d-b4db7a19c520"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "96d32893-3705-4b90-a0e8-ef6f3b8e05cd"
export const ContentSlugAa11e73e60a3400aB40dB4db7a19c520 = "footer-logo";

// id: "3a680420-71b5-45d1-b5a5-323b53d43e75"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "b51ba26e-5e77-4982-a6ee-333313ff35e4"
export const ContentSlug3a68042071b545d1B5a5323b53d43e75 = "public-contact-header-with-hero";

// id: "b2a7e72b-5f3b-4182-8542-51390ab30afa"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "bd6cdc05-3328-4ee9-ba92-cf12f73805b4"
export function HeroWrapperB2a7e72b5f3b4182854251390ab30afa(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapperB2a7e72b5f3b4182854251390ab30afa`}>
      {props["hero"] || <Hero className="Hero5b5ab7646ca84159Aa01D2bd18dc8d83" parentTag={buildClassName("Hero5b5ab7646ca84159Aa01D2bd18dc8d83", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "12dadd0b-5f3b-4e7e-ba55-c97a575513b1"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero12dadd0b5f3b4e7eBa55C97a575513b1(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero12dadd0b5f3b4e7eBa55C97a575513b1 hero`}>
      <h1 className="title">
        {props["title"] || Title27180b9522bc400482251bd86e1dad8b}
      </h1>
    </div>
  );
}

// id: "a81d53e1-f2da-491a-a613-607853386f69"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "ed0dd5e8-7caa-4cc8-9d73-985790e7b15d"
export function HeaderA81d53e1F2da491aA613607853386f69(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderA81d53e1F2da491aA613607853386f69" parentTag={buildClassName("HeaderA81d53e1F2da491aA613607853386f69", parentTag)} title="Secondary Page" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "a8259958-77d4-48cf-9bfd-1cf459a33639"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "437b53df-9db0-4fed-9ae6-8caf2083dfb9"
export function QuoteA825995877d448cf9bfd1cf459a33639(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteA825995877d448cf9bfd1cf459a33639" parentTag={buildClassName("QuoteA825995877d448cf9bfd1cf459a33639", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "8272055f-aa79-46d9-8a2d-05d43d7cc1c5"
// title: ""
// type: :text
// key: "className"
// parent_id: "3116ec8b-a6cd-487b-bfd6-cfbffe29d49e"
export const ClassName8272055fAa7946d98a2d05d43d7cc1c5 = "public-header-with-hero home-page";

// id: "d6921da7-ab98-4c54-ab6b-7b27043e9d4d"
// title: ""
// type: :text
// key: "className"
// parent_id: "06e89f1e-fef7-4af5-b918-456890db7df0"
export const ClassNameD6921da7Ab984c54Ab6b7b27043e9d4d = "main-content";

// id: "9da1fcbf-4034-4b0e-a9ac-2078c83bba53"
// title: ""
// type: :text
// key: "title"
// parent_id: "a0883012-e397-431d-9369-36b36a04881c"
export const Title9da1fcbf40344b0eA9ac2078c83bba53 = "Join Us";

// id: "dde291d5-7380-429d-92b3-b71ca3a77964"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageDde291d57380429d92b3B71ca3a77964(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageDde291d57380429d92b3B71ca3a77964 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header1f6f1921D62f4104Adcd468ddf692f7d" parentTag={buildClassName("Header1f6f1921D62f4104Adcd468ddf692f7d", parentTag)} contentSlug="about-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      {props["main"] || <MainEae672f0C6544db8B6be7f4af16704ef />}
      {props["footer"] || <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterAaf451f27eae415287416d835fcc5d6f" {...props} />}
    </div>
  );
}

// id: "354fb5aa-64b1-47cd-9edf-bc8501bbfe11"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "7a3d3681-c0fe-400d-bec1-360f5ac7a908"
export function Header354fb5aa64b147cd9edfBc8501bbfe11(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header354fb5aa64b147cd9edfBc8501bbfe11" parentTag={buildClassName("Header354fb5aa64b147cd9edfBc8501bbfe11", parentTag)} as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" contentSlug="join-us-header-with-hero" {...props} />
  );
}

// id: "a7416aa4-6f71-4f0a-bc17-7244eeff26da"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d1b033fc-0182-4c69-9f63-3236d7c13e29"
export function FooterA7416aa46f714f0aBc177244eeff26da(props: any) {
  return (
    <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterA7416aa46f714f0aBc177244eeff26da" {...props} />
  );
}

// id: "3805a121-ce63-4155-acf5-18e4ff7f18c2"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e7e7dc0e-8d0b-4785-ada6-8c409b5a2481"
export const ContentSlug3805a121Ce634155Acf518e4ff7f18c2 = "public-contact-main-content";

// id: "6a8b3dc2-7c13-4697-beea-c47c49d1b610"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "0bc4e619-6eec-4350-b545-f9fb85b51e10"
export function Label6a8b3dc27c134697BeeaC47c49d1b610(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Label6a8b3dc27c134697BeeaC47c49d1b610" parentTag={buildClassName("Label6a8b3dc27c134697BeeaC47c49d1b610", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "d7fba451-221d-472c-9d2e-30c4da2e63dd"
// title: ""
// type: :text
// key: "subType"
// parent_id: "3116ec8b-a6cd-487b-bfd6-cfbffe29d49e"
export const SubTypeD7fba451221d472c9d2e30c4da2e63dd = "header_with_hero";

// id: "d3c1810e-b29e-4e97-bbb1-ebf98210ab3a"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageD3c1810eB29e4e97Bbb1Ebf98210ab3a(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageD3c1810eB29e4e97Bbb1Ebf98210ab3a`}>
      {props["header"] || <ContentItem className="HeaderD2611df5051043b1838f758fd1ed89ef" parentTag={buildClassName("HeaderD2611df5051043b1838f758fd1ed89ef", parentTag)} contentSlug="public-events-header-with-hero" title="Public Events" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterD9460608Ca704befB49bA9798248b17a" {...props} />}
    </div>
  );
}

// id: "b802c87e-f183-43b0-af29-43498ebbf938"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "35ad53d5-5a8b-4182-bf8b-1374cacd5381"
export function HeaderB802c87eF18343b0Af2943498ebbf938(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderB802c87eF18343b0Af2943498ebbf938" parentTag={buildClassName("HeaderB802c87eF18343b0Af2943498ebbf938", parentTag)} contentSlug="local-partnership-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "96d32893-3705-4b90-a0e8-ef6f3b8e05cd"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "1ce00e2e-46bf-4344-bff5-c5eb99362d6a"
export function Logo96d3289337054b90A0e8Ef6f3b8e05cd(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo96d3289337054b90A0e8Ef6f3b8e05cd" parentTag={buildClassName("Logo96d3289337054b90A0e8Ef6f3b8e05cd", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "2dec1864-7bf5-44ed-9479-8a24ceb9e4bb"
// title: ""
// type: :text
// key: "subType"
// parent_id: "33137a86-8def-4635-a92d-13f75e0faae8"
export const SubType2dec18647bf544ed94798a24ceb9e4bb = "header_with_hero";

// id: "04a5a533-8d61-4fe1-8112-d5f2e9838ecf"
// title: ""
// type: :text
// key: "title"
// parent_id: "d2611df5-0510-43b1-838f-758fd1ed89ef"
export const Title04a5a5338d614fe18112D5f2e9838ecf = "Public Events";

// id: "0af98c4f-85e6-4f52-8854-5722f2286e3a"
// title: ""
// type: :text
// key: "as"
// parent_id: "1f6f1921-d62f-4104-adcd-468ddf692f7d"
export const As0af98c4f85e64f5288545722f2286e3a = "header";

// id: "7a3d3681-c0fe-400d-bec1-360f5ac7a908"
// title: "Join Us Page"
// type: :html
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage7a3d3681C0fe400dBec1360f5ac7a908(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} JoinUsPage7a3d3681C0fe400dBec1360f5ac7a908`}>
      {props["header"] || <ContentItem className="Header354fb5aa64b147cd9edfBc8501bbfe11" parentTag={buildClassName("Header354fb5aa64b147cd9edfBc8501bbfe11", parentTag)} as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" contentSlug="join-us-header-with-hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterFe0c17f5837c42abBaf28074ce1cce9c" {...props} />}
    </div>
  );
}

// id: "27180b95-22bc-4004-8225-1bd86e1dad8b"
// title: ""
// type: :text
// key: "title"
// parent_id: "12dadd0b-5f3b-4e7e-ba55-c97a575513b1"
export const Title27180b9522bc400482251bd86e1dad8b = "Default Title";

// id: "7994955b-d823-4e4c-9f1e-9e511370e279"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "fd4a8154-9c63-4ca4-9839-ee69c8e0f9a4"
export function Navigation7994955bD8234e4c9f1e9e511370e279(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation7994955bD8234e4c9f1e9e511370e279" parentTag={buildClassName("Navigation7994955bD8234e4c9f1e9e511370e279", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "8aff2a4a-97e2-439c-ab5c-0b57f58c9e8b"
// title: ""
// type: :text
// key: "as"
// parent_id: "b802c87e-f183-43b0-af29-43498ebbf938"
export const As8aff2a4a97e2439cAb5c0b57f58c9e8b = "header";

// id: "386e9284-c1aa-47e3-b15d-b3e1c427e5a4"
// title: ""
// type: :text
// key: "as"
// parent_id: "a81d53e1-f2da-491a-a613-607853386f69"
export const As386e9284C1aa47e3B15dB3e1c427e5a4 = "header";

// id: "43b644ee-568d-48f8-90da-e98fab07ead8"
// title: ""
// type: :text
// key: "as"
// parent_id: "d2611df5-0510-43b1-838f-758fd1ed89ef"
export const As43b644ee568d48f890daE98fab07ead8 = "header";

// id: "1b7e4624-5cf8-4c7c-b1ab-2ad4d5cdd502"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages1b7e46245cf84c7cB1ab2ad4d5cdd502(props: any) {
  return (
    <SecondaryPageEd0dd5e87caa4cc89d73985790e7b15d parentTag="ApplicationPages1b7e46245cf84c7cB1ab2ad4d5cdd502" header={<SecondaryMarketingHeader277710feDaf14b0eAff6C00eb69ec087 parentTag="HeaderA0883012E397431d936936b36a04881c" title="Join Us" />} {...props} />
  );
}

// id: "aaf451f2-7eae-4152-8741-6d835fcc5d6f"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "dde291d5-7380-429d-92b3-b71ca3a77964"
export function FooterAaf451f27eae415287416d835fcc5d6f(props: any) {
  return (
    <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterAaf451f27eae415287416d835fcc5d6f" {...props} />
  );
}

// id: "d0a39a93-7f87-4c7e-a108-2425c3cd0c8a"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "437b53df-9db0-4fed-9ae6-8caf2083dfb9"
export function FooterD0a39a937f874c7eA1082425c3cd0c8a(props: any) {
  return (
    <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterD0a39a937f874c7eA1082425c3cd0c8a" {...props} />
  );
}

// id: "35fa0d28-ce94-4610-8f35-9a38b74842bc"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "8d5f94b3-9984-4776-ad5f-6484d40848bf"
export const LogoType35fa0d28Ce9446108f359a38b74842bc = "DEFAULT";

// id: "b78c7349-7d2a-4963-805b-82aa27c78405"
// title: ""
// type: :text
// key: "className"
// parent_id: "354fb5aa-64b1-47cd-9edf-bc8501bbfe11"
export const ClassNameB78c73497d2a4963805b82aa27c78405 = "public-header-with-hero secondary-page";

// id: "38c17f30-0534-4caa-9b1c-6973a059c2cb"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "8800c0ae-225b-4fd1-af66-a5b9a158fa63"
export const PostSlug38c17f3005344caa9b1c6973a059c2cb = "home-page-cards";

// id: "7580816d-bf30-4a4f-bb32-27a7965a6491"
// title: "Contact Us"
// type: :html
// key: "public-contact-page"
// parent_id: nil
export function PublicContactPage7580816dBf304a4fBb3227a7965a6491(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicContactPage7580816dBf304a4fBb3227a7965a6491 gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderB51ba26e5e774982A6ee333313ff35e4" parentTag={buildClassName("HeaderB51ba26e5e774982A6ee333313ff35e4", parentTag)} as="header" contentSlug="public-contact-header-with-hero" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      <main>
        {props["content"] || <ContentItem className="ContentE7e7dc0e8d0b4785Ada68c409b5a2481" parentTag={buildClassName("ContentE7e7dc0e8d0b4785Ada68c409b5a2481", parentTag)} subType="post" contentSlug="public-contact-main-content" className="main-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="Footer45daaebf1e844a3b908c1094a7b8b558" {...props} />}
    </div>
  );
}

// id: "1f6f1921-d62f-4104-adcd-468ddf692f7d"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "dde291d5-7380-429d-92b3-b71ca3a77964"
export function Header1f6f1921D62f4104Adcd468ddf692f7d(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header1f6f1921D62f4104Adcd468ddf692f7d" parentTag={buildClassName("Header1f6f1921D62f4104Adcd468ddf692f7d", parentTag)} contentSlug="about-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "33137a86-8def-4635-a92d-13f75e0faae8"
// title: "Contact Header Clone CEM6GZI2IPRP07Y1J"
// type: :gf_preset
// key: "header"
// parent_id: "d1b033fc-0182-4c69-9f63-3236d7c13e29"
export function Header33137a868def4635A92d13f75e0faae8(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header33137a868def4635A92d13f75e0faae8" parentTag={buildClassName("Header33137a868def4635A92d13f75e0faae8", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="public-faq-header-with-hero" as="header" {...props} />
  );
}

// id: "0618a791-6141-4859-923d-816cb22ca51c"
// title: ""
// type: :text
// key: "title"
// parent_id: "6dc471df-adf7-42b9-a573-757df71b0cea"
export const Title0618a79161414859923d816cb22ca51c = "Secondary Marketing Title 2";

// id: "9f5377d9-2e78-47cb-b648-f47ae93991ef"
// title: ""
// type: :text
// key: "className"
// parent_id: "b51ba26e-5e77-4982-a6ee-333313ff35e4"
export const ClassName9f5377d92e7847cbB648F47ae93991ef = "public-header-with-hero secondary-page";

// id: "5b5ab764-6ca8-4159-aa01-d2bd18dc8d83"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "b2a7e72b-5f3b-4182-8542-51390ab30afa"
export function Hero5b5ab7646ca84159Aa01D2bd18dc8d83(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero5b5ab7646ca84159Aa01D2bd18dc8d83" parentTag={buildClassName("Hero5b5ab7646ca84159Aa01D2bd18dc8d83", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "d1b033fc-0182-4c69-9f63-3236d7c13e29"
// title: "FAQ - Frequently Asked Questions"
// type: :html
// key: "public-faq-page"
// parent_id: nil
export function PublicFaqPageD1b033fc01824c699f633236d7c13e29(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicFaqPageD1b033fc01824c699f633236d7c13e29 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header33137a868def4635A92d13f75e0faae8" parentTag={buildClassName("Header33137a868def4635A92d13f75e0faae8", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="public-faq-header-with-hero" as="header" {...props} />}
      <main>
        {props["content"] || <ContentItem className="Content06e89f1eFef74af5B918456890db7df0" parentTag={buildClassName("Content06e89f1eFef74af5B918456890db7df0", parentTag)} className="main-content" subType="post" contentSlug="public-faq-main-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterA7416aa46f714f0aBc177244eeff26da" {...props} />}
    </div>
  );
}

// id: "8c67e6f3-aded-4fcf-b9d9-900c2f05701a"
// title: "Local Partnership - Page Content"
// type: :gf_preset
// key: "page-content"
// parent_id: "35ad53d5-5a8b-4182-bf8b-1374cacd5381"
export function PageContent8c67e6f3Aded4fcfB9d9900c2f05701a(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="PageContent8c67e6f3Aded4fcfB9d9900c2f05701a" parentTag={buildClassName("PageContent8c67e6f3Aded4fcfB9d9900c2f05701a", parentTag)} className="main-inner" {...props} />
  );
}

// id: "a9782f8a-57c8-4185-8d88-e0ac8ee0147e"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "eae672f0-c654-4db8-b6be-7f4af16704ef"
export function CardsA9782f8a57c841858d88E0ac8ee0147e(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsA9782f8a57c841858d88E0ac8ee0147e" parentTag={buildClassName("CardsA9782f8a57c841858d88E0ac8ee0147e", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "6d293db2-88ff-4d67-b1e2-917f6aeddffa"
// title: ""
// type: :text
// key: "subType"
// parent_id: "354fb5aa-64b1-47cd-9edf-bc8501bbfe11"
export const SubType6d293db288ff4d67B1e2917f6aeddffa = "header_with_hero";

// id: "b8e0e282-50be-4142-8156-e205d3b398dd"
// title: ""
// type: :text
// key: "className"
// parent_id: "33137a86-8def-4635-a92d-13f75e0faae8"
export const ClassNameB8e0e28250be41428156E205d3b398dd = "public-header-with-hero secondary-page";

// id: "842ac92c-f8ad-48d5-8a13-2569ceeb4831"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "6a8b3dc2-7c13-4697-beea-c47c49d1b610"
export const LogoType842ac92cF8ad48d58a132569ceeb4831 = "DEFAULT";

// id: "437b53df-9db0-4fed-9ae6-8caf2083dfb9"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage437b53df9db04fed9ae68caf2083dfb9(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const PageQuote = AppStore.presets["PageQuote"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage437b53df9db04fed9ae68caf2083dfb9 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header3116ec8bA6cd487bBfd6Cfbffe29d49e" parentTag={buildClassName("Header3116ec8bA6cd487bBfd6Cfbffe29d49e", parentTag)} className="public-header-with-hero home-page" subType="header_with_hero" contentSlug="home-header-with-hero" as="header" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack1525bda819f0458cAce9Aa9ab049d2e9" parentTag={buildClassName("WelcomeBack1525bda819f0458cAce9Aa9ab049d2e9", parentTag)} {...props} />}
      {props["main"] || <Main273edafcDd1d4e4dBbb011d468311858 />}
      {props["footer"] || <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterD0a39a937f874c7eA1082425c3cd0c8a" {...props} />}
    </div>
  );
}

// id: "273edafc-dd1d-4e4d-bbb0-11d468311858"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "437b53df-9db0-4fed-9ae6-8caf2083dfb9"
export function Main273edafcDd1d4e4dBbb011d468311858(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main273edafcDd1d4e4dBbb011d468311858`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards8800c0ae225b4fd1Af66A5b9a158fa63" parentTag={buildClassName("Cards8800c0ae225b4fd1Af66A5b9a158fa63", parentTag)} postSlug="home-page-cards" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />}
      </div>
      {props["quote"] || <PageQuote className="QuoteD5061c26B88f446e885d07fd2e3b0654" parentTag={buildClassName("QuoteD5061c26B88f446e885d07fd2e3b0654", parentTag)} contentSlug="home-page-quote" {...props} />}
    </main>
  );
}

// id: "f18895c5-c632-4dbe-a181-b99e9d6ecbb7"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "fe710b4c-04e3-4c0e-940f-f1d9d0d4b0b8"
export const NavMenuSlugF18895c5C6324dbeA181B99e9d6ecbb7 = "footer-nav";

// id: "45533637-41a8-48b8-bc8f-7a61016578fc"
// title: ""
// type: :text
// key: "className"
// parent_id: "e7e7dc0e-8d0b-4785-ada6-8c409b5a2481"
export const ClassName4553363741a848b8Bc8f7a61016578fc = "main-content";

// id: "e4313f1f-321d-4c16-a339-d4114ac1b7d2"
// title: ""
// type: :text
// key: "class"
// parent_id: "7994955b-d823-4e4c-9f1e-9e511370e279"
export const ClassE4313f1f321d4c16A339D4114ac1b7d2 = "navigation";

// id: "776b30a2-5dcc-4e18-bdd4-4c1492dfaa14"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "a9782f8a-57c8-4185-8d88-e0ac8ee0147e"
export const PostSlug776b30a25dcc4e18Bdd44c1492dfaa14 = "about-us-cards";

// id: "6dc471df-adf7-42b9-a573-757df71b0cea"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "277710fe-daf1-4b0e-aff6-c00eb69ec087"
export function Hero6dc471dfAdf742b9A573757df71b0cea(props: any) {
  return (
    <SecondaryMarketingHero12dadd0b5f3b4e7eBa55C97a575513b1 parentTag="Hero6dc471dfAdf742b9A573757df71b0cea" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "5b9a6810-40a3-44ff-8fd8-bdfdbfb0df03"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "3116ec8b-a6cd-487b-bfd6-cfbffe29d49e"
export const ContentSlug5b9a681040a344ff8fd8Bdfdbfb0df03 = "home-header-with-hero";

// id: "51bde61e-8ee5-4d67-a097-97ddea576867"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "33137a86-8def-4635-a92d-13f75e0faae8"
export const ContentSlug51bde61e8ee54d67A09797ddea576867 = "public-faq-header-with-hero";

// id: "c5e11e55-9754-4320-b270-50380d770d9f"
// title: ""
// type: :text
// key: "url"
// parent_id: "0bc4e619-6eec-4350-b545-f9fb85b51e10"
export const UrlC5e11e5597544320B27050380d770d9f = "/";

// id: "5f412f1a-c3f3-4f3e-bce0-c62e3c7f8e66"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "6a8b3dc2-7c13-4697-beea-c47c49d1b610"
export const ContentSlug5f412f1aC3f34f3eBce0C62e3c7f8e66 = "header-logo";

// id: "d2611df5-0510-43b1-838f-758fd1ed89ef"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "d3c1810e-b29e-4e97-bbb1-ebf98210ab3a"
export function HeaderD2611df5051043b1838f758fd1ed89ef(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderD2611df5051043b1838f758fd1ed89ef" parentTag={buildClassName("HeaderD2611df5051043b1838f758fd1ed89ef", parentTag)} contentSlug="public-events-header-with-hero" title="Public Events" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "fe0c17f5-837c-42ab-baf2-8074ce1cce9c"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "7a3d3681-c0fe-400d-bec1-360f5ac7a908"
export function FooterFe0c17f5837c42abBaf28074ce1cce9c(props: any) {
  return (
    <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="FooterFe0c17f5837c42abBaf28074ce1cce9c" {...props} />
  );
}

// id: "491f8d30-da62-4795-acfd-87fcd254aa08"
// title: ""
// type: :text
// key: "className"
// parent_id: "1f6f1921-d62f-4104-adcd-468ddf692f7d"
export const ClassName491f8d30Da624795Acfd87fcd254aa08 = "public-header-with-hero secondary-page";

// id: "30b35469-49e1-4080-b65a-8dcc946f3900"
// title: ""
// type: :text
// key: "className"
// parent_id: "b802c87e-f183-43b0-af29-43498ebbf938"
export const ClassName30b3546949e14080B65a8dcc946f3900 = "public-header-with-hero secondary-page";

// id: "f0d4e893-3145-43ac-a409-e61fb5c7eab0"
// title: ""
// type: :text
// key: "className"
// parent_id: "a81d53e1-f2da-491a-a613-607853386f69"
export const ClassNameF0d4e893314543acA409E61fb5c7eab0 = "public-header-with-hero secondary-page";

// id: "7cdb14e2-3489-4ccd-80c8-b3cc1f200159"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "d5061c26-b88f-446e-885d-07fd2e3b0654"
export const ContentSlug7cdb14e234894ccd80c8B3cc1f200159 = "home-page-quote";

// id: "45daaebf-1e84-4a3b-908c-1094a7b8b558"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "7580816d-bf30-4a4f-bb32-27a7965a6491"
export function Footer45daaebf1e844a3b908c1094a7b8b558(props: any) {
  return (
    <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="Footer45daaebf1e844a3b908c1094a7b8b558" {...props} />
  );
}

// id: "8282c231-7d78-4707-b7bc-6f6356b1c322"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "1ce00e2e-46bf-4344-bff5-c5eb99362d6a"
export function Groupflow8282c2317d784707B7bc6f6356b1c322(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow8282c2317d784707B7bc6f6356b1c322" parentTag={buildClassName("Groupflow8282c2317d784707B7bc6f6356b1c322", parentTag)} {...props} />
  );
}

// id: "25868e2a-6c20-4c78-8978-1174765f5193"
// title: ""
// type: :text
// key: "className"
// parent_id: "d2611df5-0510-43b1-838f-758fd1ed89ef"
export const ClassName25868e2a6c204c7889781174765f5193 = "public-header-with-hero secondary-page";

// id: "313448e9-53ed-4d26-a25b-e61b6034f89b"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "7994955b-d823-4e4c-9f1e-9e511370e279"
export const NavMenuSlug313448e953ed4d26A25bE61b6034f89b = "marketing-primary-nav";

// id: "06e89f1e-fef7-4af5-b918-456890db7df0"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "d1b033fc-0182-4c69-9f63-3236d7c13e29"
export function Content06e89f1eFef74af5B918456890db7df0(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Content06e89f1eFef74af5B918456890db7df0" parentTag={buildClassName("Content06e89f1eFef74af5B918456890db7df0", parentTag)} className="main-content" subType="post" contentSlug="public-faq-main-content" {...props} />
  );
}

// id: "1525bda8-19f0-458c-ace9-aa9ab049d2e9"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "437b53df-9db0-4fed-9ae6-8caf2083dfb9"
export function WelcomeBack1525bda819f0458cAce9Aa9ab049d2e9(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack1525bda819f0458cAce9Aa9ab049d2e9" parentTag={buildClassName("WelcomeBack1525bda819f0458cAce9Aa9ab049d2e9", parentTag)} {...props} />
  );
}

// id: "41eb6a3d-0069-490c-9058-efc7694bdfde"
// title: ""
// type: :text
// key: "subType"
// parent_id: "b802c87e-f183-43b0-af29-43498ebbf938"
export const SubType41eb6a3d0069490c9058Efc7694bdfde = "header_with_hero";

// id: "e19cd53b-25b2-47ba-83a0-57c230083016"
// title: ""
// type: :text
// key: "subType"
// parent_id: "a81d53e1-f2da-491a-a613-607853386f69"
export const SubTypeE19cd53b25b247ba83a057c230083016 = "header_with_hero";

// id: "d85896e2-cc11-4189-a8f2-fbc4f20f43f5"
// title: ""
// type: :text
// key: "subType"
// parent_id: "d2611df5-0510-43b1-838f-758fd1ed89ef"
export const SubTypeD85896e2Cc114189A8f2Fbc4f20f43f5 = "header_with_hero";

// id: "12a851c3-16d9-4f93-af27-08e4804b7a07"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "5b5ab764-6ca8-4159-aa01-d2bd18dc8d83"
export const PostSlug12a851c316d94f93Af2708e4804b7a07 = "home-hero";

// id: "bd6cdc05-3328-4ee9-ba92-cf12f73805b4"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "437b53df-9db0-4fed-9ae6-8caf2083dfb9"
export function HeaderWrapperBd6cdc0533284ee9Ba92Cf12f73805b4(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapperBd6cdc0533284ee9Ba92Cf12f73805b4`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopFd4a81549c634ca49839Ee69c8e0f9a4 parentTag="HeaderTop20eacd5a7b0240bbA325Fc5099587928" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapperB2a7e72b5f3b4182854251390ab30afa />}
    </div>
  );
}

// id: "1b6fd4fc-4218-4727-9cf4-74e718d990b9"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "ed0dd5e8-7caa-4cc8-9d73-985790e7b15d"
export function Footer1b6fd4fc421847279cf474e718d990b9(props: any) {
  return (
    <DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a parentTag="Footer1b6fd4fc421847279cf474e718d990b9" {...props} />
  );
}

// id: "18f0ecea-c3ae-4eed-baa4-58f534cdf1f0"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "a8259958-77d4-48cf-9bfd-1cf459a33639"
export const ContentSlug18f0eceaC3ae4eedBaa458f534cdf1f0 = "home-page-quote";

// id: "1b520624-8b96-4b1a-a251-613665b3b9dd"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "354fb5aa-64b1-47cd-9edf-bc8501bbfe11"
export const ContentSlug1b5206248b964b1aA251613665b3b9dd = "join-us-header-with-hero";

// id: "4763d9dd-6e27-4e11-806e-ef1d3b469ec8"
// title: ""
// type: :text
// key: "subType"
// parent_id: "06e89f1e-fef7-4af5-b918-456890db7df0"
export const SubType4763d9dd6e274e11806eEf1d3b469ec8 = "post";

// id: "11e54eb9-7d32-4759-87e5-6204c343fd4a"
// title: ""
// type: :text
// key: "title"
// parent_id: "277710fe-daf1-4b0e-aff6-c00eb69ec087"
export const Title11e54eb97d32475987e56204c343fd4a = "Secondary Marketing Title 1";

// id: "e7e7dc0e-8d0b-4785-ada6-8c409b5a2481"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "7580816d-bf30-4a4f-bb32-27a7965a6491"
export function ContentE7e7dc0e8d0b4785Ada68c409b5a2481(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="ContentE7e7dc0e8d0b4785Ada68c409b5a2481" parentTag={buildClassName("ContentE7e7dc0e8d0b4785Ada68c409b5a2481", parentTag)} subType="post" contentSlug="public-contact-main-content" className="main-content" {...props} />
  );
}

// id: "5abd9153-c054-4791-97b8-bd9b6969b3cc"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "96d32893-3705-4b90-a0e8-ef6f3b8e05cd"
export const LogoType5abd9153C054479197b8Bd9b6969b3cc = "FOOTER";

// id: "483beae7-d8fc-4267-a69e-fdc6f39bdc91"
// title: ""
// type: :text
// key: "subType"
// parent_id: "b51ba26e-5e77-4982-a6ee-333313ff35e4"
export const SubType483beae7D8fc4267A69eFdc6f39bdc91 = "header_with_hero";

// id: "b76fd4d0-0480-47fb-ad27-1de3500e1860"
// title: ""
// type: :text
// key: "class"
// parent_id: "0bc4e619-6eec-4350-b545-f9fb85b51e10"
export const ClassB76fd4d0048047fbAd271de3500e1860 = "linked-logo";

// id: "b51ba26e-5e77-4982-a6ee-333313ff35e4"
// title: "Contact Header"
// type: :gf_preset
// key: "header"
// parent_id: "7580816d-bf30-4a4f-bb32-27a7965a6491"
export function HeaderB51ba26e5e774982A6ee333313ff35e4(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderB51ba26e5e774982A6ee333313ff35e4" parentTag={buildClassName("HeaderB51ba26e5e774982A6ee333313ff35e4", parentTag)} as="header" contentSlug="public-contact-header-with-hero" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "8d5f94b3-9984-4776-ad5f-6484d40848bf"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "fd4a8154-9c63-4ca4-9839-ee69c8e0f9a4"
export function Logo8d5f94b399844776Ad5f6484d40848bf(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo8d5f94b399844776Ad5f6484d40848bf" parentTag={buildClassName("Logo8d5f94b399844776Ad5f6484d40848bf", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "a41bde3e-e3c7-4828-a4fb-0c523c4ae267"
// title: ""
// type: :text
// key: "as"
// parent_id: "3116ec8b-a6cd-487b-bfd6-cfbffe29d49e"
export const AsA41bde3eE3c74828A4fb0c523c4ae267 = "header";

// id: "f4484f62-f6a5-4232-adcd-b9eb2cf952a9"
// title: ""
// type: :text
// key: "as"
// parent_id: "33137a86-8def-4635-a92d-13f75e0faae8"
export const AsF4484f62F6a54232AdcdB9eb2cf952a9 = "header";

// id: "8800c0ae-225b-4fd1-af66-a5b9a158fa63"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "273edafc-dd1d-4e4d-bbb0-11d468311858"
export function Cards8800c0ae225b4fd1Af66A5b9a158fa63(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards8800c0ae225b4fd1Af66A5b9a158fa63" parentTag={buildClassName("Cards8800c0ae225b4fd1Af66A5b9a158fa63", parentTag)} postSlug="home-page-cards" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "55ded871-9bf9-4054-9cf9-992e8a2259e4"
// title: ""
// type: :text
// key: "subType"
// parent_id: "1f6f1921-d62f-4104-adcd-468ddf692f7d"
export const SubType55ded8719bf940549cf9992e8a2259e4 = "header_with_hero";

// id: "4722ea44-9644-4778-852a-f788c55e1729"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "8800c0ae-225b-4fd1-af66-a5b9a158fa63"
export const ButtonClass4722ea4496444778852aF788c55e1729 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "eafa3eab-f76d-4ff7-a1dc-4b20ed1437f4"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "06e89f1e-fef7-4af5-b918-456890db7df0"
export const ContentSlugEafa3eabF76d4ff7A1dc4b20ed1437f4 = "public-faq-main-content";

const Components = {
  LocalPartnershipPage35ad53d55a8b4182Bf8b1374cacd5381,
  FooterD9460608Ca704befB49bA9798248b17a,
  MainEae672f0C6544db8B6be7f4af16704ef,
  SubType5d11231320014fb889f12fe863798112,
  ClassB105e87e50a047818997Dd78af443170,
  QuoteD5061c26B88f446e885d07fd2e3b0654,
  DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a,
  LinksFe710b4c04e34c0e940fF1d9d0d4b0b8,
  CopyrightB413d9a3336148f79410E528cd3edc98,
  As3b28500aBbde4fa6Ab58Fbf284591d0e,
  Title82d0eb90Ce4e4f0b9a69Cf3dafca1b64,
  ContentSlug3ba28bc9127946b596754e145c67530d,
  DefaultHeaderTopFd4a81549c634ca49839Ee69c8e0f9a4,
  Header3116ec8bA6cd487bBfd6Cfbffe29d49e,
  ContentSlug3713f0b0D4664bc5846b094f0f2f0753,
  ContentSlugE5343bc093ab4c049c7aCb45aebea60e,
  ContentSlugEcdd10783c984119A8e27c657e601d53,
  SecondaryPageEd0dd5e87caa4cc89d73985790e7b15d,
  Footer177f0cf884724c6dAab0Bf594aacc9b4,
  HeaderTopAf4db5ce506042a58b0aE380c8f6f3c4,
  HeaderTop20eacd5a7b0240bbA325Fc5099587928,
  As2fdf47e0Bb07447aB444244d4d53b708,
  SecondaryMarketingHeader277710feDaf14b0eAff6C00eb69ec087,
  LinkedLogo0bc4e6196eec4350B545F9fb85b51e10,
  HeaderA0883012E397431d936936b36a04881c,
  ContentSlugAa11e73e60a3400aB40dB4db7a19c520,
  ContentSlug3a68042071b545d1B5a5323b53d43e75,
  HeroWrapperB2a7e72b5f3b4182854251390ab30afa,
  SecondaryMarketingHero12dadd0b5f3b4e7eBa55C97a575513b1,
  HeaderA81d53e1F2da491aA613607853386f69,
  QuoteA825995877d448cf9bfd1cf459a33639,
  ClassName8272055fAa7946d98a2d05d43d7cc1c5,
  ClassNameD6921da7Ab984c54Ab6b7b27043e9d4d,
  Title9da1fcbf40344b0eA9ac2078c83bba53,
  AboutUsPageDde291d57380429d92b3B71ca3a77964,
  Header354fb5aa64b147cd9edfBc8501bbfe11,
  FooterA7416aa46f714f0aBc177244eeff26da,
  ContentSlug3805a121Ce634155Acf518e4ff7f18c2,
  Label6a8b3dc27c134697BeeaC47c49d1b610,
  SubTypeD7fba451221d472c9d2e30c4da2e63dd,
  PublicEventsPageD3c1810eB29e4e97Bbb1Ebf98210ab3a,
  HeaderB802c87eF18343b0Af2943498ebbf938,
  Logo96d3289337054b90A0e8Ef6f3b8e05cd,
  SubType2dec18647bf544ed94798a24ceb9e4bb,
  Title04a5a5338d614fe18112D5f2e9838ecf,
  As0af98c4f85e64f5288545722f2286e3a,
  JoinUsPage7a3d3681C0fe400dBec1360f5ac7a908,
  Title27180b9522bc400482251bd86e1dad8b,
  Navigation7994955bD8234e4c9f1e9e511370e279,
  As8aff2a4a97e2439cAb5c0b57f58c9e8b,
  As386e9284C1aa47e3B15dB3e1c427e5a4,
  As43b644ee568d48f890daE98fab07ead8,
  ApplicationPages1b7e46245cf84c7cB1ab2ad4d5cdd502,
  FooterAaf451f27eae415287416d835fcc5d6f,
  FooterD0a39a937f874c7eA1082425c3cd0c8a,
  LogoType35fa0d28Ce9446108f359a38b74842bc,
  ClassNameB78c73497d2a4963805b82aa27c78405,
  PostSlug38c17f3005344caa9b1c6973a059c2cb,
  PublicContactPage7580816dBf304a4fBb3227a7965a6491,
  Header1f6f1921D62f4104Adcd468ddf692f7d,
  Header33137a868def4635A92d13f75e0faae8,
  Title0618a79161414859923d816cb22ca51c,
  ClassName9f5377d92e7847cbB648F47ae93991ef,
  Hero5b5ab7646ca84159Aa01D2bd18dc8d83,
  PublicFaqPageD1b033fc01824c699f633236d7c13e29,
  PageContent8c67e6f3Aded4fcfB9d9900c2f05701a,
  CardsA9782f8a57c841858d88E0ac8ee0147e,
  SubType6d293db288ff4d67B1e2917f6aeddffa,
  ClassNameB8e0e28250be41428156E205d3b398dd,
  LogoType842ac92cF8ad48d58a132569ceeb4831,
  HomePage437b53df9db04fed9ae68caf2083dfb9,
  Main273edafcDd1d4e4dBbb011d468311858,
  NavMenuSlugF18895c5C6324dbeA181B99e9d6ecbb7,
  ClassName4553363741a848b8Bc8f7a61016578fc,
  ClassE4313f1f321d4c16A339D4114ac1b7d2,
  PostSlug776b30a25dcc4e18Bdd44c1492dfaa14,
  Hero6dc471dfAdf742b9A573757df71b0cea,
  ContentSlug5b9a681040a344ff8fd8Bdfdbfb0df03,
  ContentSlug51bde61e8ee54d67A09797ddea576867,
  UrlC5e11e5597544320B27050380d770d9f,
  ContentSlug5f412f1aC3f34f3eBce0C62e3c7f8e66,
  HeaderD2611df5051043b1838f758fd1ed89ef,
  FooterFe0c17f5837c42abBaf28074ce1cce9c,
  ClassName491f8d30Da624795Acfd87fcd254aa08,
  ClassName30b3546949e14080B65a8dcc946f3900,
  ClassNameF0d4e893314543acA409E61fb5c7eab0,
  ContentSlug7cdb14e234894ccd80c8B3cc1f200159,
  Footer45daaebf1e844a3b908c1094a7b8b558,
  Groupflow8282c2317d784707B7bc6f6356b1c322,
  ClassName25868e2a6c204c7889781174765f5193,
  NavMenuSlug313448e953ed4d26A25bE61b6034f89b,
  Content06e89f1eFef74af5B918456890db7df0,
  WelcomeBack1525bda819f0458cAce9Aa9ab049d2e9,
  SubType41eb6a3d0069490c9058Efc7694bdfde,
  SubTypeE19cd53b25b247ba83a057c230083016,
  SubTypeD85896e2Cc114189A8f2Fbc4f20f43f5,
  PostSlug12a851c316d94f93Af2708e4804b7a07,
  HeaderWrapperBd6cdc0533284ee9Ba92Cf12f73805b4,
  Footer1b6fd4fc421847279cf474e718d990b9,
  ContentSlug18f0eceaC3ae4eedBaa458f534cdf1f0,
  ContentSlug1b5206248b964b1aA251613665b3b9dd,
  SubType4763d9dd6e274e11806eEf1d3b469ec8,
  Title11e54eb97d32475987e56204c343fd4a,
  ContentE7e7dc0e8d0b4785Ada68c409b5a2481,
  LogoType5abd9153C054479197b8Bd9b6969b3cc,
  SubType483beae7D8fc4267A69eFdc6f39bdc91,
  ClassB76fd4d0048047fbAd271de3500e1860,
  HeaderB51ba26e5e774982A6ee333313ff35e4,
  Logo8d5f94b399844776Ad5f6484d40848bf,
  AsA41bde3eE3c74828A4fb0c523c4ae267,
  AsF4484f62F6a54232AdcdB9eb2cf952a9,
  Cards8800c0ae225b4fd1Af66A5b9a158fa63,
  SubType55ded8719bf940549cf9992e8a2259e4,
  ButtonClass4722ea4496444778852aF788c55e1729,
  ContentSlugEafa3eabF76d4ff7A1dc4b20ed1437f4
}

export default Components;